import { PageHeader } from "@/components/site/PageHeader";
import { Services } from "@/components/home/Services";
import { HowItWorks } from "@/components/home/HowItWorks";
import { Doctor } from "@/components/home/Doctor";
import { Gallery } from "@/components/home/Gallery";
import { Reviews } from "@/components/home/Reviews";
import { Faq } from "@/components/home/Faq";
import { Contact } from "@/components/home/Contact";

export const ServicesPage = () => (
  <div data-testid="services-page">
    <PageHeader eyebrow="Our services" title="Gentle care for every little stage" text="From the first tooth to teenage braces, every treatment is explained in kid-friendly words and done at your child's pace." />
    <Services />
    <HowItWorks />
  </div>
);

export const AboutPage = () => (
  <div data-testid="about-page">
    <PageHeader eyebrow="Meet the doctor" title="Dr. Anuj Shah & Tooth Buds" text="A full-service pediatric dental practice in Malad West for infants, toddlers, teens and special children." />
    <Doctor />
    <Gallery />
  </div>
);

export const ReviewsPage = () => (
  <div data-testid="reviews-page">
    <PageHeader eyebrow="Reviews" title="What parents say" text="Real reviews from families. Visited us recently? We'd love to hear your story." />
    <Reviews />
  </div>
);

export const FaqPage = () => (
  <div data-testid="faq-page">
    <PageHeader eyebrow="FAQ" title="Answers for curious parents" text="Still unsure? Ask Sparkle, our AI helper, or call the clinic." />
    <Faq />
  </div>
);

export const ContactPage = () => (
  <div data-testid="contact-page">
    <PageHeader eyebrow="Contact" title="Come say hi!" text="Call, WhatsApp or drop by during clinic hours." />
    <Contact />
  </div>
);
